enum TireActionTarget {
  TIRE = 'TIRE',
  AXLE = 'AXLE',
  ALL = 'ALL',
}

export default TireActionTarget;